import { AxiosResponse } from "axios";

import {
  IAddBillableDeviceRequest,
  IBillableDevice,
} from "../../@types/admin/AdminBillableDevice";
import { api } from "../api";

/**
 * Billable devices admin page (EN-5129) — first page migrated from Retool.
 * Calls the same /Retool endpoints the Retool app uses; the API authorizes
 * them for SuperAdmin JWTs via RetoolAccessHandler.
 */
export const billableDevicesService = {
  async getBillableDevices(): Promise<AxiosResponse<IBillableDevice[]>> {
    return api.get<IBillableDevice[]>("/Retool/BillableDevices");
  },

  async getDeviceTypes(): Promise<AxiosResponse<string[]>> {
    return api.get<string[]>("/Retool/BillableDevices/DeviceTypes");
  },

  async addBillableDevice(
    request: IAddBillableDeviceRequest
  ): Promise<AxiosResponse<IBillableDevice>> {
    return api.post<IBillableDevice>("/Retool/BillableDevices", request);
  },

  async archiveBillableDevice(id: string): Promise<AxiosResponse<void>> {
    return api.post<void>(`/Retool/BillableDevices/${id}/Archive`);
  },
};
